import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSelectionsEnrichedLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 116,
	height: 116,
	viewBox: "0 0 116 116",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M58 109C86.1665 109 109 86.1665 109 58C109 29.8335 86.1665 7 58 7C29.8335 7 7 29.8335 7 58C7 86.1665 29.8335 109 58 109Z",
			fill: "#D8FFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105.15 59.49C101.84 59.49 99.1504 56.8 99.1504 53.49C99.1504 50.18 101.84 47.49 105.15 47.49C108.46 47.49 111.15 50.18 111.15 53.49C111.15 56.8 108.46 59.49 105.15 59.49ZM105.15 49.49C102.94 49.49 101.15 51.28 101.15 53.49C101.15 55.7 102.94 57.49 105.15 57.49C107.36 57.49 109.15 55.7 109.15 53.49C109.15 51.28 107.36 49.49 105.15 49.49Z",
			fill: "#00D8D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.7598 39.86C91.1405 39.86 92.2598 38.7407 92.2598 37.36C92.2598 35.9793 91.1405 34.86 89.7598 34.86C88.3791 34.86 87.2598 35.9793 87.2598 37.36C87.2598 38.7407 88.3791 39.86 89.7598 39.86Z",
			fill: "#00D8D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9199 62.41C16.8529 62.41 18.4199 60.843 18.4199 58.91C18.4199 56.977 16.8529 55.41 14.9199 55.41C12.9869 55.41 11.4199 56.977 11.4199 58.91C11.4199 60.843 12.9869 62.41 14.9199 62.41Z",
			fill: "#00D8D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5405 88L22.4805 84.06C23.0705 83.47 23.0705 82.52 22.4805 81.94C21.8905 81.36 20.9405 81.35 20.3605 81.94L16.4205 85.88L12.4805 81.94C11.8905 81.35 10.9405 81.35 10.3605 81.94C9.78047 82.53 9.77047 83.48 10.3605 84.06L14.3005 88L10.3605 91.94C9.77047 92.53 9.77047 93.48 10.3605 94.06C10.6505 94.35 11.0405 94.5 11.4205 94.5C11.8005 94.5 12.1905 94.35 12.4805 94.06L16.4205 90.12L20.3605 94.06C20.6505 94.35 21.0405 94.5 21.4205 94.5C21.8005 94.5 22.1905 94.35 22.4805 94.06C23.0705 93.47 23.0705 92.52 22.4805 91.94L18.5405 88Z",
			fill: "#00D8D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.7601 15.03H88.1901V9.45996C88.1901 8.62996 87.5201 7.95996 86.6901 7.95996C85.8601 7.95996 85.1901 8.62996 85.1901 9.45996V15.03H79.6201C78.7901 15.03 78.1201 15.7 78.1201 16.53C78.1201 17.36 78.7901 18.03 79.6201 18.03H85.1901V23.6C85.1901 24.43 85.8601 25.1 86.6901 25.1C87.5201 25.1 88.1901 24.43 88.1901 23.6V18.03H93.7601C94.5901 18.03 95.2601 17.36 95.2601 16.53C95.2601 15.7 94.5901 15.03 93.7601 15.03Z",
			fill: "#00D8D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.0702 62.42V82.1C89.0702 83.2 88.1802 84.1 87.0802 84.1H41.7402C35.2102 84.1 29.9102 78.8 29.9102 72.27C29.9102 65.74 35.2102 60.44 41.7402 60.44H87.0802C88.1802 60.44 89.0702 61.33 89.0702 62.43V62.42Z",
			fill: "#001A43"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.5501 51.86L90.0301 70.47C90.3201 71.69 89.5701 72.91 88.3601 73.2L44.5501 83.76C38.2001 85.29 31.8001 81.38 30.2701 75.03C28.7401 68.68 32.6501 62.28 39.0001 60.75L82.8101 50.19C84.0301 49.9 85.2501 50.65 85.5401 51.86H85.5501Z",
			fill: "#0597A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9503 23.97L62.6203 28.66C63.8003 28.96 64.5203 30.16 64.2303 31.34L53.2303 75.1C51.6403 81.43 45.2003 85.28 38.8703 83.69C32.5403 82.1 28.6903 75.66 30.2803 69.33L41.2803 25.57C41.5803 24.39 42.7803 23.67 43.9603 23.96L43.9503 23.97Z",
			fill: "#00D8D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.0804 75.72C42.6986 75.72 44.0104 74.4082 44.0104 72.79C44.0104 71.1718 42.6986 69.86 41.0804 69.86C39.4622 69.86 38.1504 71.1718 38.1504 72.79C38.1504 74.4082 39.4622 75.72 41.0804 75.72Z",
			fill: "#0597A3"
		})
	]
});
export default SvgSelectionsEnrichedLight;
